const errorMessages = [
  {
    type: "invalid_card_type",
    message:
      "Flocknote only accepts Visa, Mastercard, American Express, and Discover cards.",
  },
  {
    type: "invalid_card_number",
    message: "It doesn't look like that's a valid card number.",
  },
  {
    type: "empty_card_number",
    message: "It doesn't look like you filled out a credit card number.",
  },
  {
    type: "empty_expiration_date",
    message: "It doesn't look like you filled out your card's expiration date.",
  },
  {
    type: "empty_cvc",
    message:
      "It doesn't look like you filled out your card's CVC code.  This is the 3-digit code on the back of your card.",
  },
  {
    type: "empty_cvc_amex",
    message:
      "It doesn't look like you filled out your card's CVC code.  This is the 4-digit code on the front of your card.",
  },
  {
    type: "invalid_cvc",
    message:
      "It doesn't look like that is a valid CVC code. This is the 3-digit code on the back of your card.",
  },
  {
    type: "invalid_cvc_amex",
    message:
      "It doesn't look like that is a valid CVC code. This is the 4-digit code on the front of your card.",
  },
  {
    type: "expiration_in_past",
    message: "It looks like this card is expired.",
  },
  {
    type: "invalid_expiration",
    message: "Something is odd about that expiration date.",
  },
  {
    type: "empty_name",
    message: "Please add a first and last name to the card.",
  },
  {
    type: "empty_zip",
    message: "It doesn't look like you filled out your zip code.",
  },
  {
    type: "invalid_zip",
    message: "It doesn't look like that is a valid zip code.",
  },
  {
    type: "name_too_long",
    message: "The cardholder name cannot be more than 26 characters.",
  },
  {
    type: "invalid_year",
    message: "It looks like the expiration year is not valid.",
  },
  {
    type: "invalid_routing_number",
    message: "It doesn't look like that is a valid routing number.",
  },
  {
    type: "empty_account_number",
    message: "Please add your account number.",
  },
  {
    type: "empty_routing_number",
    message: "Please add your bank's routing number.",
  },
  {
    type: "generic_stax_tokenization_error",
    message:
      "Something went wrong saving your information. Please make sure it is all correct.",
  },
  {
    type: "stax_ach_person_name",
    message: "Please fill out your name.",
  },
  {
    type: "could_not_unpause",
    message:
      "Your card has updated, but you will need to unpause recurring gifts that use this card.",
  },
];

export default errorMessages;
